module.exports = __webpack_public_path__ + "img/清华大学.7a4bc363.png";